import React from 'react';
import PratusTextArea from 'components/DesignSystems/New/PratusTextArea';
import { useIcsFormPdfPreview } from 'components/IAP/context/IcsFormPdfPreviewContext';
import {
  useIncidentInfo,
  useUpdateIcsInfo,
} from 'components/IAP/hooks/incidentInfoHooks';
import { useSearchParams } from 'react-router';
import ICSWidget from '../ICSWidget';
import { ConditionalCollapsibleCard } from 'components/IAP/ConditionalCollapsibleCard';
import { MedicalAidStationsTable } from './MedicalAidStationsTable';
import { TransportationsTable } from './TransportationsTable';
import { HospitalsTable } from './HospitalsTable';
import { getIncidentCardTitle } from '../../USCGPage';
import { useIncidentPermissions } from 'components/IAP/hooks/incidentHooks';

const MedicalPlan: React.FC = () => {
  const [searchParams] = useSearchParams();
  const phase = searchParams.get('phase');
  const mode = searchParams.get('mode');
  const sectionKey = `${phase}-${mode}-medical-plan`;

  const { exportAsForm } = useIcsFormPdfPreview();
  const { data: incidentInfo } = useIncidentInfo();
  const { mutate: updateIcsInfo } = useUpdateIcsInfo();

  const { data: incidentPermissions } = useIncidentPermissions();
  const canEditCards = incidentPermissions?.['incident:editCards'] ?? false;

  const handleExport = () => {
    void exportAsForm({
      formname: 'ICS_206_CG',
      data: {},
      mapSketch: null,
    });
  };

  return (
    <ConditionalCollapsibleCard
      sectionKey={sectionKey}
      className="planning-widget"
      contentClassName="content mt-2"
      headerLeft={
        <ICSWidget.HeaderLeft
          iconName="favorite"
          iconColor="primary"
          title={getIncidentCardTitle('medicalPlan')}
          subtitle=""
        />
      }
      headerRight={
        <ICSWidget.HeaderRight
          icsRoles={['IC/UC', 'PSC', 'Situation Unit Leader']}
          handleExport={handleExport}
          exportText="Preview ICS-206"
        />
      }
    >
      <MedicalAidStationsTable readOnly={!canEditCards} />
      <TransportationsTable readOnly={!canEditCards} />
      <HospitalsTable readOnly={!canEditCards} />
      <PratusTextArea
        label="Special Medical Emergency Procedures"
        value={incidentInfo?.specialMedicalEmergencyProcedures ?? ''}
        onSave={(value) =>
          updateIcsInfo({ specialMedicalEmergencyProcedures: value })
        }
        rows={4}
        placeholder="Describe special medical emergency procedures for this incident..."
        disabled={!canEditCards}
      />
    </ConditionalCollapsibleCard>
  );
};

export default MedicalPlan;
